import { t } from "ttag";

import type { AuthProviderButtonProps } from "metabase/plugins/types";

import S from "./KeycloakButton.module.css";

export const KeycloakButton = ({
  isCard,
  redirectUrl,
}: AuthProviderButtonProps) => {
  const ssoUrl = redirectUrl
    ? `/auth/keycloak?redirect=${encodeURIComponent(redirectUrl)}`
    : "/auth/keycloak";

  return isCard ? (
    <a href={ssoUrl} className={S.CardLink}>
      <span className={S.CardText}>{t`Sign in with SSO`}</span>
    </a>
  ) : (
    <a href={ssoUrl} className={S.TextLink}>
      {t`Sign in with SSO`}
    </a>
  );
};
